/**
 * The `tel:` address for a phone number as an admin typed it ("+91 98765 43210", "1800-123-4567"): only digits and a leading plus are kept, so a
 * phone dials it whatever spacing or brackets were typed. The text shown on screen stays exactly as typed.
 *
 * Returns '' when there is nothing to dial. Callers must then draw the text WITHOUT a link: an empty href is a link to the current page.
 */
export function phoneHref(phone: string | null | undefined): string {
  const raw = String(phone ?? '').trim();
  const digits = raw.replace(/[^0-9]/g, '');
  return digits ? `tel:${raw.startsWith('+') ? '+' : ''}${digits}` : '';
}
